import { createContext } from "react";
import socketio from "socket.io-client";
const SOCKET_URL = "https://chatboxpro.herokuapp.com/"
//process.env.SOCKET_URL

export const socket = socketio.connect(SOCKET_URL);
export const SocketContext = createContext();
